import { Effect, Layer, type Context } from "effect";
import { immutableModelDependencyFailure } from "./model.ts";
import { DiffEditorIo } from "./diff-editor-io.ts";
import { EditorPlatform } from "../editor/platform-service.ts";
type Port = Context.Service.Shape<typeof DiffEditorIo>;
const load = Effect.tryPromise({
  try: () => import("./diff-editor-monaco-live.ts"),
  catch: immutableModelDependencyFailure
});
export const DiffEditorIoLive = Layer.effect(DiffEditorIo, Effect.gen(function* () {
  const platform = yield* EditorPlatform;
  return DiffEditorIo.of({
    acquire: Effect.fn("Frontend.DiffEditorIo.acquire")(function* (...args: Parameters<Port["acquire"]>) { yield* platform.ready.pipe(Effect.mapError(immutableModelDependencyFailure)); return yield* (yield* load).diffEditorIo.acquire(...args); }),
    configure: Effect.fn("Frontend.DiffEditorIo.configure")(function* (...args: Parameters<Port["configure"]>) { return yield* (yield* load).diffEditorIo.configure(...args); }),
    models: Effect.fn("Frontend.DiffEditorIo.models")(function* (...args: Parameters<Port["models"]>) { return yield* (yield* load).diffEditorIo.models(...args); }),
    reveal: Effect.fn("Frontend.DiffEditorIo.reveal")(function* (...args: Parameters<Port["reveal"]>) { return yield* (yield* load).diffEditorIo.reveal(...args); }),
    mounted: Effect.fn("Frontend.DiffEditorIo.mounted")(function* (...args: Parameters<Port["mounted"]>) { return yield* (yield* load).diffEditorIo.mounted(...args); })
  });
}));
